import { TimePicker as MuiTimePicker } from "@material-ui/pickers";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

interface TimePickerProps {
  className?: string;
  placeholder: string;
  setValue: (date?: Date) => void;
  value?: Date;
  disabled?: boolean;
}

const TimePicker: React.FC<TimePickerProps> = (props: TimePickerProps) => {
  const handleDateChange = (date: MaterialUiPickersDate) => {
    props.setValue(date?.toDate());
  };

  const classes = props.className ? props.className : "";

  return (
    <MuiTimePicker
      className={`${classes} pr-0`}
      ampm={false}
      value={props.value ? props.value : null}
      label={props.placeholder}
      onChange={(date) => handleDateChange(date)}
      okLabel="OK"
      clearLabel="LIMPIAR"
      cancelLabel="CANCELAR"
      variant="dialog"
      inputVariant="outlined"
      clearable
      disabled={props.disabled}
    />
  );
};

export default TimePicker;
